/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import ProductOverlay from "../../components/overlays/product-overlay";
import { SIGNUP_PAGE_REGEX, getProductPageRegex } from "routing/routes";

/**
 * Given a product page path,
 * returns a product slug and unique ID.
 *
 * @param {String} path
 * @param {Object} queryParams
 * @returns {String, String}
 */
function getSlugAndUid(path, queryParams) {
    const pathMatch = path.match(getProductPageRegex());
    const productSlug = pathMatch[2];
    const productUid = queryParams.product_overlay_uid && queryParams.product_overlay_uid[0];
    const linkId = queryParams.link_id && queryParams.link_id[0];

    return { productSlug, productUid, linkId };
}

export default {
    enter(path, queryParams, parent) {
        const isErrorPage = parent.el.querySelector(".http-error-layout");
        if (isErrorPage) {
            return parent.findComponent("default-layout");
        }
        // If we landed on a product page (which has the same
        // URL pattern as a product overlay), do nothing.
        const productPage = parent.findComponent("product-page");
        if (productPage) {
            return productPage;
        }

        const { productSlug, productUid, linkId } = getSlugAndUid(path, queryParams);
        const overlayArgs = { productSlug };
        if (productUid) {
            overlayArgs.productUid = productUid;
        }
        if (linkId) {
            overlayArgs.linkId = linkId;
        }

        const productOverlayPage = parent.findComponent("product-overlay");
        if (productOverlayPage && productOverlayPage.options.productSlug == productSlug) {
            return productOverlayPage;
        }

        const productOverlay = new ProductOverlay(overlayArgs);
        productOverlay.appendTo(parent);

        // Return a promise that resolves once the overlay is opened
        return productOverlay.open().then(function() {
            return productOverlay;
        });
    },

    update(path, queryParams, component) {
        const isProductPage = component.name === "product-page";
        if (isProductPage) {
            return;
        }

        const { productSlug, productUid, linkId } = getSlugAndUid(path, queryParams);
        const overlayArgs = { productSlug };
        if (productUid) {
            overlayArgs.productUid = productUid;
        }
        if (linkId) {
            overlayArgs.linkId = linkId;
        }

        if (productUid === undefined && component.options.productSlug === productSlug) {
            // In the case of returning to the product overlay from a child route
            // the product slug will not have changed but we still want to track the page view
            component.trackPageView();
        } else if (productUid !== undefined && component.options.productUid === productUid) {
            // essentially the same as above, we don't want to re-render the
            // overlay but we do want to track the page view
            component.trackPageView();
        } else {
            // Updating the product slug will cause the product-overlay component
            // to re-render its content with the new product
            component.updateOptions({
                productUid: productUid,
                productSlug: productSlug
            });
        }
    },

    exit(path, queryParams, component) {
        if (path.match(SIGNUP_PAGE_REGEX)) {
            return;
        }
        return component.close();
    }
};

